import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { HttpClient } from "@angular/common/http";
import { InvoiceLabelTypeTaxInfo } from "../../model/invoice-label-type-tax-info";
import { InvoiceCashDesk } from "../../model/invoice-cash-desk";
import { AuthService } from "../auth.service";
import { CashDeskService } from "../cash-desk.service";
import { CashDeskUserOpen } from "../../model/cash-desk-user-open";
import { InvoicePointService } from "./invoice-point.service";
import { InvoiceNumberBookPoint } from "../../model/invoice-number-book-point";
import { ReportViewer } from "../../model/report-viewer";
import { CreditCardFilter } from "../../model/credit-card-filter";
import { BankFilter } from "../../model/bank-filter";

@Injectable()
export abstract class InvoiceCashDeskService {
  constructor(
    public http: HttpClient,
    public dataService: DataService,
    public authService: AuthService,
    public invoicePointService: InvoicePointService,
    public cashDeskService: CashDeskService
  ) {}


  abstract getInvoiceCashDeskPdf(invoiceId: number): Promise<ReportViewer>;
  abstract getInvoiceCashDesk(
    medicalAppointmentId?: number,
    invoiceId?: number,
    code?: string
  ): Promise<InvoiceCashDesk>;
  abstract getCashDeskUserOpen(
    allInvoicePoint: boolean,
    allService: boolean,
    equipmentId?: number,
    serviceId?: number,
    invoicePointId?: number
  ): Promise<CashDeskUserOpen>;
  abstract getNextNumber(
    cashDeskInvoicePointId: number,
    invoiceLabelTypeId: number
  ): Promise<InvoiceNumberBookPoint>;
  abstract createInvoiceCash(InvoiceCashDesk: InvoiceCashDesk): Promise<number>;
  abstract canEdit(): boolean;
  abstract canEditAmount(): boolean;
  abstract canEditInvoicePoint(): boolean;
  abstract isPatient(): boolean;
  abstract sendMailPatientInvoiceCashDeskPdf(
    invoiceId: number,
    appointmentId?: number,
    atentionCode?: string,
    email?: string
  ): Promise<boolean>;
}
